import React, { useContext, } from "react";
import { UserContext } from "../../../context/UserContext";
import { Redirect } from "react-router";


const Linkedinjobs = () => {
  const context = useContext(UserContext);

  if (!context.user?.email) {
    return <Redirect to="/" />
  }
    return (
      <div>
      <section class="padding-default2">
          <h5>LinkedIn Recomendation</h5>
 <div class="panel panel-primary card" >
   <div class="panel-heading">Link My Certificate and Degree</div>

   <div class="panel-body">
     <div class="row ">
       <div class="col-md-12">
       <a 
        href="https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME"
         id="l_jobs" class="btn_1 rounded outline"  style={{lineheight: "1.2"}}
         rel="noreferrer" target="_blank">
                     Link Certificates to Linkedin Account</a>

                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                   <a  href="https://www.linkedin.com/profile/add?startTask=SCHOOL_NAME"
                    id="l_jobs1" class="btn_1 rounded outline" style={{lineheight: "1.2"}}
                     rel="noreferrer" target="_blank">
                      Link Degree to Linkedin Account
                    </a>
       </div>
     </div>
   </div>
 </div>
</section>
<br /><br />
   </div>
    );
  };


export default Linkedinjobs;